<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_5505_548)">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M1.77778 0H14.2222C15.2 0 16 0.8 16 1.77778V14.2222C16 15.2 15.2 16 14.2222 16H1.77778C0.8 16 0 15.2 0 14.2222V1.77778C0 0.8 0.8 0 1.77778 0ZM4.66667 6C3.5621 6 2.66667 6.89543 2.66667 8C2.66667 9.10457 3.5621 10 4.66667 10H11.3333C12.4379 10 13.3333 9.10457 13.3333 8C13.3333 6.89543 12.4379 6 11.3333 6H4.66667Z" fill="currentColor" />
	</g>
	<defs>
		<clipPath id="clip0_5505_548">
			<rect width="16" height="16" rx="3" fill="white" />
		</clipPath>
	</defs>
</svg>
